/**
 * OfflineBanner — fixed-top banner shown when the browser loses internet connectivity.
 */

import { FiWifiOff } from 'react-icons/fi'
import { useOnlineStatus } from '../../hooks/useOnlineStatus'

export function OfflineBanner() {
  const isOnline = useOnlineStatus()

  if (isOnline) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-orange-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium shadow-lg">
      <FiWifiOff size={16} />
      <span>You're offline. Some features may be unavailable.</span>
    </div>
  )
}
